export default "__VITE_ASSET__D39mkJ7r__"